<template>
  <div class="row" v-if="isReady()">
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="filter-comment" id="filter-comment">
        <div class="filter-comment__search">
          <label class="form-label">Поисковый запрос</label>
          <div class="row g-2">
            <div class="col">
              <div class="input-icon">
                <input @keyup.enter="events.onSearch" type="text" v-model="bootData.search" class="form-control" placeholder="Напишите текст комментария">
                <button class="btn input-icon-addon__button" @click="events.onSearch">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="10" cy="10" r="7" />
                    <line x1="21" y1="21" x2="15" y2="15" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-comment__date">
          <label class="form-label">Дата публикации</label>
          <Datepicker auto-apply v-model="bootData.date" @update:modelValue="events.applyDate" range multi-calendars locale="ru" format="dd.MM.yyyy" placeholder="Выбрать дату" :enable-time-picker="false" />
        </div>

        <div class="filter-comment__select users">
          <label class="form-label">Пользователь</label>
          <Multiselect
              v-model="bootData.users"
              :options="variantsData.users"
              label="name"
              track-by="name"
              :searchable="true"
              :createOption="true"
              mode="tags"
              @change="events.onUser"
              placeholder="Не выбрано"
              noOptionsText="Введите значение и нажмите enter"
          />
        </div>

        <div class="filter-comment__select channels">
          <label class="form-label">Канал</label>
          <Multiselect @change="events.onChannels" v-model="bootData.channels" mode="tags" placeholder="Не выбрано" noResultsText="Не найдено" :trackBy="'name'" :searchable="true" :options="variantsData.channels">
            <template v-slot:tag="{ option, handleTagRemove, disabled }">
              <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
                <div class="user-name">{{ option.name }}</div>
                <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
                  <span class="multiselect-tag-remove-icon"></span>
                </span>
              </div>
            </template>
            <template v-slot:option="{ option }">
              <div class="option-user">
                <div class="user-name"> {{ option.name }}</div>
              </div>
            </template>
          </Multiselect>
        </div>

        <div class="filter-comment__select channels">
          <TypeVisible :data="{
            val: bootData.type_visibility,
          }" @onChange="events.onTypeVisible"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import Multiselect from "@/plugins/multiselect"
import Datepicker from "@/plugins/datepicker"
import DT from "@/services/DT"
import TypeVisible from "./components/type_visible/Index"

export default defineComponent({
  name: "Filter",
  components: {
    Datepicker,
    Multiselect,
    TypeVisible,
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    let filterInit = ref(false)

    let bootData = reactive({
      search: props.payload.search ?? '',
      date: props.payload.date ?? null,
      users: props.payload.users ?? [],
      channels: props.payload.channels ?? [],
      type_visibility: props.payload.type_visibility ?? null,
    })

    let ready = ref(false)

    const variantsData = reactive({
      users: [],
      channels: [],
    })

    const events = {
      applyDate: () => {
        onFilter(false)
      },
      onUser: (value) => {
        // тут приходится подменять вручную, а не использовать v-model
        // так как v-model реагирует перед событием и не учитывает текущий выбор
        // и наполняется предыдущим набором данных
        bootData.users = value
        onFilter(false)
      },
      onChannels: (value) => {
        // тут приходится подменять вручную, а не использовать v-model
        // так как v-model реагирует перед событием и не учитывает текущий выбор
        // и наполняется предыдущим набором данных
        bootData.channels = value
        onFilter(false)
      },
      onSearch: () => {
        onFilter(false)
      },
      onTypeVisible: (value) => {
        bootData.type_visibility = value
        onFilter(false)
      },
    }

    onMounted(async () => {
      readyOff()
      await channels()
      readyOn()

      onFilter(true)
    })

    watch(() => props.payload.channels, (val) => {
      bootData.channels = val
    }, { immediate: true })

    watch(() => props.payload.type_visibility, (val) => {
      bootData.type_visibility = val
    }, { immediate: true })

    function channels() {
      let variants = [];

      variants.push(
          {
            "id": 1,
            "name": "Сайт hl.ru",
          },
          {
            "id": 4,
            "name": "Aliexpress",
          },
          {
            "id": 5,
            "name": "DailySales",
          },
          {
            "id": 9,
            "name": "Live",
          },
          {
            "id": 3,
            "name": "Молния",
          },
          {
            "id": 8,
            "name": "Нашли дешевле",
          },
          {
            "id": 13,
            "name": "Промопушка",
          },
          {
            "id": 7,
            "name": "Travel",
          },
          {
            "id": 12,
            "name": "Ultima",
          },
          {
            "id": 11,
            "name": "Haunt",
          },
          {
            "id": 2,
            "name": "Халявщики",
          },
          {
            "id": 10,
            "name": "Эконом",
          },
      )

      channelsMultiSelect(variants)
    }

    function onFilter(force) {
      if (force === true || filterInit.value === true) {
        pushParent()
        filterInit.value = true
      }
    }

    function channelsMultiSelect(items) {
      for (let prop in items) {
        let obj = items[prop]

        variantsData.channels.push({
          value: Number(obj["id"]),
          name: obj["name"],
        })
      }
    }

    function pushParent() {
      emit("onFilter", getResult())
    }

    function getResult() {
      let date = forDateResult(bootData.date)

      return {
        search: bootData.search,
        date: {
          from: date[0],
          to: date[1],
        },
        users: bootData.users,
        channels: bootData.channels,
        type_visibility: bootData.type_visibility,
      }
    }

    function forDateResult(date) {
      if (date === null) {
        return [
          null,
          null,
        ]
      }

      let from = new DT(date[0]).startTimeOfDay()
      let to = new DT(date[1]).endTimeOfDay()

      from.setMonth(from.getMonthNatural())
      to.setMonth(to.getMonthNatural())

      return [
        from.get("%Y-%M-%D"),
        to.get("%Y-%M-%D"),
      ]
    }

    function isReady() {
      return ready.value
    }

    function readyOn() {
      ready.value = true
    }

    function readyOff() {
      ready.value = false
    }

    return {
      events,
      bootData,
      variantsData,
      isReady,
    }
  }
})
</script>

<style scoped></style>
